import React from "react";

import type {
  HeaderLayoutContent,
  HeaderLayoutProps,
} from "scmp-app/components/header/layouts/types";
import {
  AbsoluteCenterFeatureContainer,
  HomeMiniHeaderCenterWrapper,
} from "scmp-app/components/header/styles";

export const getHomeMiniLayout = ({
  config,
  features,
  initEdition,
}: HeaderLayoutProps): HeaderLayoutContent => ({
  center: (
    <HomeMiniHeaderCenterWrapper>
      {features.oneLineMenu({
        appBarVariant: config?.appBarVariant,
        initEdition,
        showIn: "desktopUp",
      })}
      <AbsoluteCenterFeatureContainer>
        {features.logoTextLink({ showIn: "mobileAndTablet" })}
      </AbsoluteCenterFeatureContainer>
    </HomeMiniHeaderCenterWrapper>
  ),
  left: (
    <>
      {features.hamburgerMenu({ showIn: "mobileAndTablet" })}
      {features.logoLink({ showIn: "desktopUp" })}
      {features.search({ showIn: "desktopUp" })}
    </>
  ),
  right: (
    <>
      {features.myNews({
        showIn: "mobileUp",
        showWhenLoggedIn: true,
      })}
      {features.dashboard({
        showIn: "mobileUp",
        showUserLabel: false,
      })}
    </>
  ),
});
